window.addEventListener("load", (e) => {
    document.querySelectorAll('.block-galleria').forEach((block) => {

        document.querySelectorAll('.secondary-images .image').forEach((image) => {
            const primaryImage = block.querySelector('.primary-image img');
            image.onclick = function (e) {
                block.dataset.index = image.dataset.index;
                primaryImage.src = image.dataset.src;
                block.querySelector('#image-counter').textContent = block.dataset.index;
            }
        })

        document.querySelector('.button-prev').onclick = function (e) {
            const primaryImage = block.querySelector('.primary-image img');
            const index = parseInt(block.dataset.index);


            if ( index > 1 ) {
                const nextImage = block.querySelector('.secondary-images .image[data-index="'+(index-1)+'"]');
                primaryImage.src = nextImage.dataset.src;
                block.dataset.index = index-1+"";
            } else {
                const nextImage = block.querySelector('.secondary-images .image[data-index="'+block.dataset.max+'"]');
                primaryImage.src = nextImage.dataset.src;
                block.dataset.index = block.dataset.max+"";
            }

            block.querySelector('#image-counter').textContent = block.dataset.index;

        }

        document.querySelector('.button-next').onclick = function (e) {
            const primaryImage = block.querySelector('.primary-image img');
            const index = parseInt(block.dataset.index);

            if ( index < block.dataset.max ) {
                const nextImage = block.querySelector('.secondary-images .image[data-index="'+(index+1)+'"]');
                primaryImage.src = nextImage.dataset.src;
                block.dataset.index = index+1+"";
            } else {
                const nextImage = block.querySelector('.secondary-images .image[data-index="'+1+'"]');
                primaryImage.src = nextImage.dataset.src;
                block.dataset.index = "1";
            }

            block.querySelector('#image-counter').textContent = block.dataset.index;

        }

    })
});